import { Device, type DeviceId, type DeviceInfo } from "@capacitor/device";
import { useEffect, useState } from "react";

export type DeviceData = {
  id: DeviceId;
  info: DeviceInfo;
};

export function useDeviceData() {
  const [deviceData, setDeviceData] = useState<DeviceData | null>(null);

  const requestDeviceData = async () => {
    const deviceId = await Device.getId();
    const deviceInfo = await Device.getInfo();
    setDeviceData({
      id: deviceId,
      info: deviceInfo,
    });
  };

  useEffect(() => {
    requestDeviceData();
  }, []);

  return deviceData;
}
